export type AssessmentType =
  | "VINELAND"
  | "CFQL2"
  | "QABF"
  | "SRS2"
  | "CPFQ_CHILD"
  | "CPFQ_CAREGIVER"
  | "VBMAPP_MILESTONES"
  | "VBMAPP_BARRIERS"
  | "VBMAPP_TRANSITION"
  | "PEAK"
  | "AFLS"
  | "ESSENTIAL_FOR_LIVING"
  | "SOCIALLY_SAVVY";

export const ASSESSMENT_DISPLAY_NAMES: Record<AssessmentType, string> = {
  VINELAND: "Vineland-3™ Adaptive Behavior Assessment",
  CFQL2: "CFQL Assessment",
  QABF: "Questions about Behavioral Function (QABF)",
  SRS2: "Social Responsiveness Scale, 2nd Edition (SRS-2)",
  CPFQ_CHILD: "CPFQ Child Assessment",
  CPFQ_CAREGIVER: "CPFQ Caregiver Assessment",
  VBMAPP_MILESTONES: "VB-MAPP: Milestones Assessment",
  VBMAPP_BARRIERS: "VB-MAPP: Barriers Assessment",
  VBMAPP_TRANSITION: "VB-MAPP: Transition Assessment",
  PEAK: "PEAK Relational Training System",
  AFLS: "Assessment of Functional Living Skills (AFLS)",
  ESSENTIAL_FOR_LIVING: "Essential for Living (EFL)",
  SOCIALLY_SAVVY: "Socially Savvy Assessment",
};
